var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column min-vh-100 pt-2 px-2 pb-0",attrs:{"id":"appcontainer"}},[_c('router-view'),_c('div',{attrs:{"id":"sitefooter"}},[_c('router-link',{attrs:{"to":"/","replace":""}},[_vm._v("MathAround")]),_vm._v("™ is © 2023 Cetati Inc.")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }